<template >
  <div name="documents">
    <FilterBar @searchChanged="setSearchValue">
      <template v-slot:filter>
        <div>
          <!-- <Dropdown
            :options="typeDropdown"
            :selected="typeSelected"
            :title="'Document Type'"
            v-on:updateOption="updateSelectedType"
            style="min-width: 10rem"
          ></Dropdown> -->
        </div>
      </template>
      <template v-slot:actions>
        <div v-if="addAccessAllowed">
          <button
            type="button"
            class="action-button hover:opacity-75 
             disabled:opacity-50 disabled:cursor-not-allowed"
            @click="addNew()"
     :disabled="!hasResourceModule"
            
          >
            <i class="fas fa-plus"></i>
            Add New
          </button>
        </div>
      </template>
    </FilterBar>

    <div class="table-wrapper">
      <div v-if="errored" class="empty">
        <p>
          We are not able to retrieve this information at the moment, please try
          back later
        </p>
      </div>

      <div id="content-area" class="w-full mx-auto h-full pb-16" v-else>
        <div v-if="!hasSearch"
        class="grid grid-cols-6 gap-6 w-11/12 mx-auto pt-10"
      >
        <div
          v-for="type in typeList" :key="type.id"
          @click="showResources(type)"
          class="text-center content-center rounded-2xl p-6 cursor-pointer hover:opacity-50 bg-gray-100"
        >
          <div class="icon bg-gray-100 rounded-xl w-10 h-8 pt-3 mx-auto">
             <i class="fas  text-xl mx-auto opacity-75 text-gray-600"
             v-bind:class="type.icon != undefined ? type.icon : 'fa-folder-minus'" ></i>
          </div>
          <h4 class="pt-3 font-bold">{{ type.name }}</h4>
        </div>
      </div>

      <div class=" w-11/12 mx-auto" v-else >
        <ResourceList :searchValue="search" :hasAccess="true"   :type="typeSelected"></ResourceList>
      </div>

   
    </div>
    </div>

   

    <ModalSlide :show="showModalAddition" @closeModal="closeAddResource">
      <template v-slot:header-icon>
        <i class="fas fa-plus"></i>
      </template>
      <template v-slot:header-title>
        Add New Resource
        <div class="text-xs">Enter details for new resource file.</div>
      </template>
      <template v-slot:body>
        <ResourceAdd @resource-added="resourceAdded" :displayKey="'library'"></ResourceAdd>
      </template>
    </ModalSlide>

    <ModalSlide v-if="typeSelected != null"  :show="showModalList"     :cssWidth="'md:w-6/12'"  @closeModal="closeListResource">
      <template v-slot:header-icon>
        <i class="fas fa-plus"></i>
      </template>
      <template v-slot:header-title>
       {{ typeSelected.name }} Resources
        <div class="text-xs">View resource files.</div>
      </template>
      <template v-slot:body>
        <ResourceList :hasAccess="hasResourceModule"  :type="typeSelected" ></ResourceList>
      </template>
    </ModalSlide>

        
  </div>
</template>

<script>
import moment from "moment";
import { mapGetters } from "vuex";
import { libraryFolders } from "@/assets/js/utils";

const ModalSlide = () => import("@/components/ModalSlide.vue");
const ResourceAdd = () => import("@/components/library/TheResourceAdd.vue");
const ResourceList = () => import("@/components/library/TheResourceList.vue");
const FilterBar = () => import("@/components/FilterBarNavigation.vue");

const Dropdown = () => import("@/components/Dropdown.vue");


export default {
  name: "documents",
  props: {},
  computed: {
    ...mapGetters({
      currentUser: "currentUser",
      currentAccess: "currentAccess",
    }),
    hasResourceModule() {
       if (this.currentUser.isOnFree) {
          return this.currentAccess.resourceAccess;
       } else {
        return true
       }
    
    },
    showForSchool() {
      return this.currentUser.isSchool == true;
    },
    showLancs() {
      return this.currentUser.schoolStyle == "lancashire";
    },
    addAccessAllowed() {
      return true
      // return (
      //   ["school", "", "organisation"].includes(this.typeSelected.value)
      // );
    },
    schoolName() {
      return this.currentUser.schoolName;
    },
  },
  data() {
    return {
      loading: true,
      errored: false,
      showModalList: false,
      showModalAddition: false,
      typeList: [],
      typeSelected: null,
      search: "",
      hasSearch: false

    };
  },
  created() {
    this.loading = true;
  },
  mounted() {
    if (this.currentUser.isOrganisation || this.currentUser.isConsul) {
      this.typeList.push({ id: 1, value: "organisation", name: "Organisation Documents", icon: "fa-sitemap" })
    } 

    if (this.showForSchool) {
      this.typeList = this.typeList.concat(libraryFolders(this.currentUser.schoolType))
    }
  },
  methods: {
    addNew() {
      this.showModalAddition = true;
    },
    closeAddResource() {
      this.showModalAddition = false;
    },
    closeListResource() {
      this.showModalList = false;
      this.typeSelected = null
    },
    resourceAdded() {
      this.closeAddResource()
    },
    showResources(type) {
      this.typeSelected = type
      this.showModalList = true
    },
    setSearchValue(value, time = 500) {
      let vm = this;
      vm.search = value
      
      if (vm.search.length >= 3) {
        this.hasSearch = true
      } else {
        this.hasSearch = false
      }
    },
    
  },
  components: {
    FilterBar,
    Dropdown,
    ResourceAdd,
    ResourceList,
    ModalSlide
  },
};
</script>

<style>

</style>


